import { lazy } from 'react';

import Main from 'src/layouts/Main/Layout';
import Home from "src/pages/home/Home";


const routes = [
    {
        path: '/',
        element: Main,
        routes: [
            {
                path: '',
                element: Home
            }

        ]
    }
];

export default routes;
